import { rangeWithDefaultsWhenEmpty } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_ATTRITION_RATE = 0;
const DEFAULT_MAX_ATTRITION_RATE = 25;

export const attritionRateDescriptor = defineFilter({
  definition: {
    id: FilterId.ATTRITION_RATE,
    name: 'Attrition Rate',
    type: FilterType.RANGE,
    min: DEFAULT_MIN_ATTRITION_RATE,
    max: DEFAULT_MAX_ATTRITION_RATE,
    isActive: false,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_ATTRITION_RATE, segmented: true },
  handler: rangeWithDefaultsWhenEmpty(
    DEFAULT_MIN_ATTRITION_RATE,
    DEFAULT_MAX_ATTRITION_RATE
  ),
});
